import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { createOptions } from '@/utils/arrayHelper'
import { camelToWords } from '@/utils/stringHelper'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import UserService from './user.service'

const useUser = () => {
  const service = new UserService()
  const baseCrud = useCrud(API_RESOURCE.USER, service)

  const queryClient = useQueryClient()

  const useUploadUsers = () => {
    return useMutation({
      mutationFn: service.uploadUser,
      onSuccess: (res) => {
        toast.info(`Successfully Upload  ${camelToWords(API_RESOURCE.USER)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }
  const useUploadVendorUsers = () => {
    return useMutation({
      mutationFn: service.uploadVendorUsers,
      onSuccess: (res) => {
        toast.info(`Successfully Upload Vendor User`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const useActivateUser = () => {
    return useMutation({
      mutationFn: service.activateUser,
      onSuccess: (res) => {
        toast.info(`Successfully Activate  ${camelToWords(API_RESOURCE.USER)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const useUserOptions = (parameter = {}) => {
    const {
      labelKey = 'fullName',
      valueKey = 'fullName',
      status = 'active',
      withNilOption = false,
      ...rest
    } = parameter
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status: status, ...rest } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status: status, ...rest } }),
      placeholderData: [],
      select: (data) => {
        return createOptions(data?.data, labelKey, valueKey, withNilOption)
      },
      enabled: Object.values(rest).every((value) => value !== undefined),
      refetchOnMount: true,
    })
  }

  return {
    //Base CRUD
    useFetchAllUsers: baseCrud.useFetchAll,
    useFetchUser: baseCrud.useFetchOne,
    useCreateUser: baseCrud.useCreate,
    useUpdateUser: baseCrud.useUpdate,
    useRemoveUser: baseCrud.useRemove,

    //Extra
    useUploadUsers,
    useActivateUser,
    useUploadVendorUsers,
    useUserOptions,
  }
}

export default useUser
